import Link from "next/link";

const imprintUrl = process.env.NEXT_PUBLIC_IMPRINT_URL || "https://www.bem-extern.de/impressum";
const privacyUrl = process.env.NEXT_PUBLIC_PRIVACY_URL || "https://www.bem-extern.de/datenschutz";

export default function LegalFooter() {
  return (
    <footer className="border-subtle text-subtle mt-auto border-t py-6 text-sm">
      <div className="mx-auto flex max-w-full items-center justify-center gap-6 px-4">
        <Link href={imprintUrl} className="hover:underline">
          Impressum
        </Link>
        <Link href={privacyUrl} className="hover:underline">
          Datenschutz
        </Link>
      </div>
    </footer>
  );
}

